import type { SVGProps } from 'react'
const SvgLoading = (props: SVGProps<SVGSVGElement>) => (
  <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
    <circle
      cx={16}
      cy={16}
      fill="none"
      r={14}
      strokeWidth={4}
      style={{
        stroke: 'hsl(var(--primary))',
        opacity: 0.2,
      }}
    />
    <circle
      cx={16}
      cy={16}
      fill="none"
      r={14}
      strokeWidth={4}
      style={{
        stroke: 'hsl(var(--primary))',
        strokeDasharray: 80,
        strokeDashoffset: 60,
      }}
    />
  </svg>
)
export default SvgLoading
